import { useEffect, useState } from "react";
import api from "@/lib/api";
import CouponCard from "@/components/CouponCard";
import { Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * "Recommended for you" strip — only renders for signed-in users.
 * Powered by /api/ai/recommendations (Claude Sonnet 4.6).
 */
export default function RecommendedForYou({ user }) {
  const [items, setItems] = useState(null);
  const [source, setSource] = useState(null);

  useEffect(() => {
    if (!user) return;
    api.get("/ai/recommendations")
      .then((r) => { setItems(r.data.recommendations || []); setSource(r.data.source); })
      .catch(() => setItems([]));
  }, [user]);

  if (!user || items === null) return null;
  if (items.length === 0) return null;

  return (
    <section className="max-w-[1400px] mx-auto px-6 py-12 relative z-10" data-testid="recommended-for-you">
      <div className="flex items-end justify-between mb-6 fade-up">
        <div>
          <div className="pf-chip pf-chip-lav w-fit">
            <Sparkles className="w-3 h-3" /> {source === "ai" ? "AI Picks" : "Just for you"}
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-medium tracking-tight mt-3 text-slate-900">
            Recommended for <span className="pf-gradient-text-2">{user.name?.split(" ")[0] || "you"}</span>
          </h2>
          <p className="text-sm text-slate-600 mt-1">
            {source === "ai"
              ? "Personalised by Cyannect AI based on your saves, favourites and claims."
              : "Trending offers from your favourite stores."}
          </p>
        </div>
        <Link to="/coupons" className="pf-btn-glass px-4 py-2 rounded-full text-xs font-semibold hidden md:inline-flex items-center gap-1">
          Browse all <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.slice(0, 6).map((c) => (
          <div key={c.id} className="relative" data-testid={`rec-item-${c.id}`}>
            <CouponCard coupon={c} />
            {c.why && (
              <div className="mt-2 text-xs text-slate-600 italic px-1 flex items-start gap-1.5">
                <Sparkles className="w-3 h-3 text-cyan-600 shrink-0 mt-0.5" />
                <span>{c.why}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
